import { useState } from "react";
import { useSelector } from "react-redux";
import useApiRequest from "../../../../utils/hooks/useApiRequest";
import useFacility from "../../../../utils/hooks/useFacility";
import { JOIN_TO_EXERCISE } from "../../../api/apiRoutes";
import { State } from "../../../store";

export default function useCourtPassRegistration() {
  const facilityIds = useFacility();
  const { post } = useApiRequest();
  const userDataId = useSelector((state: State) => state.auth.userData?.objectId);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState("");

  const joinToExerciseByPass = async (
    exerciseId: number,
    passId: string,
    assigned: boolean = false,
    onSuccess?: () => void
  ) => {
    if (!userDataId) {
      setAlert("Musisz być zalogowany aby wykonać tę operację");
      return false;
    }

    setLoading(true);
    setAlert("");

    const params = {
      webUserIds: `0,${userDataId}`,
      exerciseIds: exerciseId,
      assigned: assigned, // false = zapisywanie, true = wypisywanie
    };

    try {
      const { isError, errorTable } = await post(JOIN_TO_EXERCISE(facilityIds, passId), params);

      setLoading(false);

      if (!isError) {
        onSuccess && onSuccess();
        return true;
      } else {
        const errorMessage =
          errorTable && errorTable[0]
            ? errorTable[0]
            : assigned
            ? "Wystąpił błąd podczas wypisywania się"
            : "Wystąpił błąd podczas zapisywania";
        setAlert(errorMessage);
        return false;
      }
    } catch (error) {
      setLoading(false);
      setAlert(
        assigned ? "Wystąpił błąd podczas wypisywania się z zajęć" : "Wystąpił błąd podczas zapisywania się karnetem"
      );
      return false;
    }
  };

  const clearAlert = () => {
    setAlert("");
  };

  return {
    loading,
    alert,
    joinToExerciseByPass,
    clearAlert,
  };
}
